import React from 'react';

export const typeTemplateHtml = (type) => {
  switch (type) {
    case 'image':
      return (<div className="icon-container image center-flex"><i className="mi-image-2-fill" /></div>);
    case 'video':
      return (<div className="icon-container video center-flex"><i className="mi-video-fill" /></div>);
    case 'document':
      return (<div className="icon-container document center-flex"><i className="mi-document-pdf-16-regular" /></div>);
    default:
      return (<div className="icon-container text center-flex"><i className="mi-Text-fill" /></div>);
  }
};

export const templateIcon = (template_type) => {
  let icon;

  switch (template_type) {
    case 'text':
      icon = 'mi-message-square-fill';
      break;
    case 'image':
      icon = 'mi-image-2-fill';
      break;
    case 'document':
      icon = 'mi-pdf-fill';
      break;
    case 'video':
      icon = 'mi-video-fill';
      break;
    default:
      icon = 'mi-message-square-fill';
      break;
  }

  return icon;
};
